import { type AllowedMaterialSpec, isObject, useApiMaterialsV1AllowedMaterialSpecsList } from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type MaterialAutocompleteProps = Omit<
  AutocompleteFieldProps<AllowedMaterialSpec>,
  'options' | 'defaultValue'
> & {
  defaultValue?: AllowedMaterialSpec['id'];
};

export const AllowedMaterialSpecAutocomplete = ({ defaultValue, ...props }: MaterialAutocompleteProps) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useApiMaterialsV1AllowedMaterialSpecsList({
    search: query,
  });

  return (
    <AutocompleteField<AllowedMaterialSpec>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(option) => {
        if (isObject(option) && option?.name) {
          return option.name;
        }
        return '';
      }}
      valueField="id"
      data-testid="allowed-material-spec-autocomplete"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      {...props}
    />
  );
};
